import { vpp, VPP_API } from '../api/vpp';

export const getReferralContent = () => () =>
  vpp.get(VPP_API.referralContent).then(({ data }) => data);

export const submitReferral = (payload) => () =>
  vpp.post(VPP_API.referralProgram, payload).then(({ data }) => data);

export const logReferralTabView = () => () =>
  vpp.post(VPP_API.referralTabView).catch(() => {});
